import { render } from "./MainListSales.vue?vue&type=template&id=0b14f7d6&scoped=true"
import script from "./MainListSales.vue?vue&type=script&lang=js"
export * from "./MainListSales.vue?vue&type=script&lang=js"

import "./MainListSales.vue?vue&type=style&index=0&id=0b14f7d6&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b14f7d6"]])

export default __exports__